import { render } from "./Calendar.vue?vue&type=template&id=d2eaeae8&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=d2eaeae8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2eaeae8"

export default script